export enum AmountTypeEnum {
  absolute,
  percentage
}
